import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

type Props = {
  isValidationDisabled: boolean
  onValidationDisabledChange: (isValidationDisabled: boolean) => void
}

export const FormValidationSwitch = ({
  isValidationDisabled,
  onValidationDisabledChange,
}: Props) => {
  const translate = useTranslate()

  return (
    <Button
      aria-pressed={!isValidationDisabled}
      startIcon={isValidationDisabled ? 'Circle' : 'CheckCircle'}
      variant={isValidationDisabled ? 'discreet' : 'secondary'}
      onClick={() => onValidationDisabledChange(!isValidationDisabled)}
    >
      {translate('validation.enabled')}
    </Button>
  )
}
